import React from "react";
import { BaseIconProps } from "./baseIcon";
import { BaseIconWithPath } from "./baseIconWithPath";

export const BellIcon = React.forwardRef<SVGSVGElement, BaseIconProps>(
  (props, ref) => {
    return (
      <BaseIconWithPath
        d="M9.992 1.666c-2.96 0-5 2.04-5 5v1.666c0 .269-.135.451-.599.834l-.338.286C3 10.324 2.481 11.141 2.492 12.5a2.53 2.53 0 0 0 2.5 2.5H7.64s-.147.51-.147.833a2.5 2.5 0 1 0 5 0c0-.324-.14-.833-.14-.833h2.64a2.506 2.506 0 0 0 2.5-2.5c-.001-1.348-.521-2.179-1.562-3.047-.068-.057-.31-.241-.365-.286-.453-.379-.572-.569-.572-.834V6.666c0-2.96-2.04-5-5-5m0 1.666c2.04 0 3.334 1.294 3.334 3.334v1.666c0 .885.373 1.444 1.172 2.11.063.052.33.262.39.312.699.583.937.977.938 1.745a.846.846 0 0 1-.834.833h-5c-2.416.001-4.822.002-5 0a.835.835 0 0 1-.833-.833c-.006-.767.232-1.162.938-1.745.057-.047.304-.262.364-.312.811-.67 1.198-1.216 1.198-2.11V6.666c0-2.04 1.294-3.334 3.333-3.334m0 11.667a.834.834 0 1 1 0 1.667.834.834 0 0 1 0-1.667"
        ref={ref}
        {...props}
      />
    );
  },
);

BellIcon.displayName = "BellIcon";
